// extracted by mini-css-extract-plugin
export default {"container":"styles_container__OcX-e","title":"styles_title__dfctm","chart":"styles_chart__8xudA","text":"styles_text__GxHpr"};